import { render } from "./technology-park-classification-badge.vue?vue&type=template&id=25a39f4f&scoped=true"
import script from "./technology-park-classification-badge.vue?vue&type=script&lang=js"
export * from "./technology-park-classification-badge.vue?vue&type=script&lang=js"

import "./technology-park-classification-badge.vue?vue&type=style&index=0&id=25a39f4f&scoped=true&lang=css"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a39f4f"]])

export default __exports__